module.exports = __webpack_public_path__ + "static/addition.3b08faa2.png";